import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface TranslationEntry {
  translationKey: string;
  translationValue: string;
}

export class CustomTranslateLoader implements TranslateLoader {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<Record<string, string>> {
    return this.http.get<TranslationEntry[]>(`${this.baseUrl}translations/${lang}`).pipe(
      map((entries) => {
        const result: Record<string, string> = {};
        for (const entry of entries) {
          result[entry.translationKey] = entry.translationValue;
        }
        return result;
      }),
    );
  }
}
